<kendo-dialog-titlebar>
    {{'shared.header.confirmOperation' | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">
    <h4>{{question}}</h4>

    <div *ngIf="htmlQuestionBody" [innerHtml]="htmlQuestionBody | safe:'html'"></div>


    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>